import styled from "styled-components";
import * as colors from "../../settings/colors";

const TextArea = styled.textarea`
  display: block;
  font-family: inherit;
  font-size: 14px;
  line-height: 19px;
  box-sizing: border-box;
  width: 100%;
  padding: 7px;
  resize: vertical;
  border: 1px solid ${colors.DIVIDER};
  border-radius: 3px;

  &:focus {
    outline: 0;
    box-shadow: 0 0 0 3px #99c6f3;
  }
`;

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/forms/TextArea.js